import { Anchor, Spacer, Text, WarningIcon } from '@sparemin/blockhead';
import cn from 'classnames';
import React from 'react';

import { block } from './utils';

export type AssetOverlayLabelProps = {
  label: string;
  isAvailable?: boolean;
  icon?: React.ReactNode;
  className?: string;
};

const AssetOverlayLabel: React.FC<AssetOverlayLabelProps> = ({
  label,
  isAvailable = true,
  icon,
  className,
}) => {
  return (
    <Spacer
      space="10px"
      orientation="horizontal"
      align="center"
      justify="center"
      className={cn(block(), className)}
    >
      {icon ||
        (isAvailable ? (
          <Anchor width={12} height={12} />
        ) : (
          <WarningIcon color="#F9EB69" width={16} height={16} />
        ))}

      <Text
        variant="label"
        textTransform="uppercase"
        weight={700}
        letterSpacing="1.2px"
      >
        {label}
      </Text>
    </Spacer>
  );
};

export default AssetOverlayLabel;
